import List from './List'
import Photo from '@material-ui/icons/Photo'

export default {
  list: List,
  icon: Photo
}
